// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraphselector {
  width: 80%;
  padding: 1.5rem 1rem;
  background: hsl(200, 20%, 12%);
  max-width: 50rem;
  border-radius: 1rem;
  box-shadow: 0 10px 40px -15px hsla(0, 0%, 0%, 0.5);
}
.paragraphselector__form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
}
@media (min-width: 480px) {
  .paragraphselector__form {
    width: 50%;
    margin: 0 auto;
  }
}
.paragraphselector__label {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: center;
  color: hsl(200, 10%, 55%);
  font-family: "Bebas Neue", sans-serif;
  margin-bottom: 0.5rem;
}
@media (min-width: 480px) {
  .paragraphselector__label {
    font-size: 1.5rem;
  }
}
.paragraphselector__radio-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.paragraphselector__radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.paragraphselector__radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.paragraphselector__radio-text {
  display: inline-block;
  min-width: 2.5rem;
  padding: 0.5rem 1.2rem;
  border-radius: 2rem;
  background: hsl(200, 20%, 18%);
  color: hsl(200, 10%, 55%);
  font-family: "Bebas Neue", sans-serif;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px -4px hsl(195, 65%, 35%);
}
.paragraphselector__radio:checked + .paragraphselector__radio-text {
  background: hsl(190, 70%, 45%);
  color: hsl(180, 15%, 92%);
  box-shadow: 0 0 0 3px hsl(185, 75%, 55%);
}
.paragraphselector__button {
  width: 100%;
  border-radius: 2rem;
  background: hsl(190, 70%, 45%);
  border: none;
  color: hsl(200, 25%, 8%);
  font-size: 1.2rem;
  font-family: "Bebas Neue", sans-serif;
  font-weight: 600;
  padding: 0.75rem 0;
  box-shadow: 0 4px 30px -10px hsla(190, 70%, 45%, 0.4);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}
.paragraphselector__button:hover {
  background: hsl(185, 75%, 55%);
  box-shadow: 0 0 0 4px hsl(185, 75%, 55%);
}
.paragraphselector__button--secondary {
  background: hsl(200, 20%, 18%);
  color: hsl(180, 15%, 92%);
  box-shadow: 0 10px 40px -15px hsla(0, 0%, 0%, 0.5);
}
.paragraphselector__button--secondary:hover {
  background: hsl(200, 20%, 12%);
  box-shadow: 0 0 0 4px hsl(185, 75%, 55%);
}
.paragraphselector__button--error {
  background: hsl(0, 70%, 50%);
  box-shadow: 0 4px 20px -5px hsla(0, 70%, 50%, 0.6);
}
.paragraphselector__button--error:hover {
  background: hsl(0, 70%, 60%);
  box-shadow: 0 0 0 4px hsl(0, 70%, 60%);
}
.paragraphselector__button--disabled {
  background: hsl(200, 15%, 20%);
  color: hsl(200, 10%, 55%);
  cursor: not-allowed;
  box-shadow: none;
}
.paragraphselector__button--disabled:hover {
  background: hsl(200, 15%, 20%);
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/SiteForm/SiteForm.scss","webpack://./src/styles/partials/_variables.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,UAAA;EACA,oBAAA;EACA,8BCOa;EDNb,gBAAA;EACA,mBCDU;EDEV,kDCmBU;ADrBd;AAII;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAFR;AEdI;EFUA;IAQQ,UAAA;IACA,cAAA;EAAV;AACF;AAEI;EACI,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBCTU;EDUV,qCCzBO;ED0BP,qBAAA;AAAR;AE7BI;EFsBA;IASQ,iBAAA;EAEV;AACF;AAAI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAER;AAAI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAER;AAAI;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;AAER;AAAI;EACI,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBChDM;EDiDN,8BCxCa;EDyCb,yBCvCU;EDwCV,qCCvDO;EDwDP,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wDACI;EAGJ,6CAAA;AADR;AAGI;EACI,8BCxDQ;EDyDR,yBC3DI;ED4DJ,wCAAA;AADR;AAII;EACI,WAAA;EACA,mBCrEM;EDsEN,8BChEQ;EDiER,YAAA;EACA,wBCrEI;EDsEJ,iBAAA;EACA,qCC9EO;ED+EP,gBAAA;EACA,kBAAA;EACA,qDC1DO;ED2DP,eAAA;EACA,4CACI;AAHZ;AAKQ;EACI,8BC5EU;ED6EV,wCAAA;AAHZ;AAMQ;EACI,8BC/ES;EDgFT,yBCrFA;EDsFA,kDCtEE;ADkEd;AAKY;EACI,8BCvFC;EDwFD,wCAAA;AAHhB;AAOQ;EACI,4BCrFG;EDsFH,kDC9EG;ADyEf;AAMY;EACI,4BCvFK;EDwFL,sCAAA;AAJhB;AAQQ;EACI,8BCjGG;EDkGH,yBCjGM;EDkGN,mBAAA;EACA,gBAAA;AANZ;AAOY;EACI,8BCtGD;EDuGC,gBAAA;AALhB","sourcesContent":["@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/variables\" as *;\n\n.paragraphselector {\n    width: 80%;\n    padding: 1.5rem 1rem;\n    background: $colour-surface;\n    max-width: 50rem;\n    border-radius: $radius-card;\n    box-shadow: $shadow-card;\n\n    &__form {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n        padding: 1rem 0;\n        @include breakpoint($breakpoint-tablet) {\n            width: 50%;\n            margin: 0 auto;\n        }\n    }\n    &__label {\n        text-transform: uppercase;\n        font-weight: 600;\n        font-size: 1.1rem;\n        text-align: center;\n        color: $colour-muted-fg;\n        font-family: $font-display;\n        margin-bottom: 0.5rem;\n        @include breakpoint($breakpoint-tablet) {\n            font-size: 1.5rem;\n        }\n    }\n    &__radio-group {\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 0.75rem;\n    }\n    &__radio-label {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        position: relative;\n    }\n    &__radio {\n        position: absolute;\n        opacity: 0;\n        pointer-events: none;\n    }\n    &__radio-text {\n        display: inline-block;\n        min-width: 2.5rem;\n        padding: 0.5rem 1.2rem;\n        border-radius: $radius-pill;\n        background: $colour-surface-alt;\n        color: $colour-muted-fg;\n        font-family: $font-display;\n        font-size: 1.2rem;\n        font-weight: 600;\n        text-align: center;\n        transition:\n            background 0.2s,\n            color 0.2s,\n            box-shadow 0.2s;\n        box-shadow: 0 2px 8px -4px $colour-accent-dark;\n    }\n    &__radio:checked + &__radio-text {\n        background: $colour-accent;\n        color: $colour-fg;\n        box-shadow: 0 0 0 3px $colour-accent-light;\n    }\n\n    &__button {\n        width: 100%;\n        border-radius: $radius-pill;\n        background: $colour-accent;\n        border: none;\n        color: $colour-bg;\n        font-size: 1.2rem;\n        font-family: $font-display;\n        font-weight: 600;\n        padding: 0.75rem 0;\n        box-shadow: $shadow-ocean;\n        cursor: pointer;\n        transition:\n            background 0.2s,\n            box-shadow 0.2s;\n        &:hover {\n            background: $colour-accent-light;\n            box-shadow: 0 0 0 4px $colour-accent-light;\n        }\n\n        &--secondary {\n            background: $colour-surface-alt;\n            color: $colour-fg;\n            box-shadow: $shadow-card;\n            &:hover {\n                background: $colour-surface;\n                box-shadow: 0 0 0 4px $colour-accent-light;\n            }\n        }\n\n        &--error {\n            background: $colour-error;\n            box-shadow: $shadow-error;\n            &:hover {\n                background: $colour-error-light;\n                box-shadow: 0 0 0 4px $colour-error-light;\n            }\n        }\n\n        &--disabled {\n            background: $colour-muted;\n            color: $colour-muted-fg;\n            cursor: not-allowed;\n            box-shadow: none;\n            &:hover {\n                background: $colour-muted;\n                box-shadow: none;\n            }\n        }\n    }\n}\n","$breakpoint-mobile: 320px;\n$breakpoint-tablet: 480px;\n$breakpoint-desktop: 768px;\n\n$font-display: \"Bebas Neue\", sans-serif;\n$font-body: \"Inter\", Arial, Helvetica, sans-serif;\n\n$radius-card: 1rem;\n$radius-pill: 2rem;\n$radius: 0.75rem;\n\n$colour-bg: hsl(200, 25%, 8%);\n$colour-fg: hsl(180, 15%, 92%);\n$colour-surface: hsl(200, 20%, 12%);\n$colour-accent: hsl(190, 70%, 45%);\n$colour-accent-light: hsl(185, 75%, 55%);\n$colour-accent-dark: hsl(195, 65%, 35%);\n$colour-surface-alt: hsl(200, 20%, 18%);\n$colour-muted: hsl(200, 15%, 20%);\n$colour-muted-fg: hsl(200, 10%, 55%);\n$colour-border: hsl(200, 15%, 22%);\n$colour-error: hsl(0, 70%, 50%);\n$colour-error-light: hsl(0, 70%, 60%);\n\n$gradient-ocean: linear-gradient(135deg, hsl(195, 65%, 35%), hsl(190, 70%, 45%), hsl(185, 75%, 55%));\n$gradient-dark: linear-gradient(180deg, hsl(200, 25%, 8%), hsl(200, 30%, 5%));\n\n$shadow-ocean: 0 4px 30px -10px hsl(190, 70%, 45%, 0.4);\n$shadow-card: 0 10px 40px -15px hsl(0, 0%, 0%, 0.5);\n$shadow-error: 0 4px 20px -5px hsl(0, 70%, 50%, 0.6);\n","@mixin breakpoint($breakpoint) {\n    @media (min-width: $breakpoint) {\n        @content;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
